import React from 'react';

import { TeamKpiStyleProps } from '../../types';

export const TeamKpiStyle: React.FC<TeamKpiStyleProps> = () => {
    return <div />;
};
